import { render, staticRenderFns } from "./ModuleSection.vue?vue&type=template&id=b143cc40&scoped=true&"
import script from "./ModuleSection.vue?vue&type=script&lang=js&"
export * from "./ModuleSection.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSection.vue?vue&type=style&index=0&id=b143cc40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143cc40",
  null
  
)

export default component.exports